import { LightRecessedIcon } from './LightRecessedIcon';

/**
 * author: Michael Irigoyen
 * id F309BA75-39A7-45AC-9B1A-22D1F7D41345
 * name light-recessed
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/light-recessed.svg
 * tags
 * - Home Automation 
 */
export const CanLightIcon = LightRecessedIcon;
export default CanLightIcon